import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, first, map } from "rxjs/operators";
import { SessionUserDataService } from "@shared/services/user-data/session-user-data.service";

export const UserDataGuard: CanActivateFn = (): Observable<boolean> => {
  const sessionUserDataService: SessionUserDataService = inject(SessionUserDataService);

  if (sessionUserDataService.user()) return of(true);

  return sessionUserDataService.loadUserData$().pipe(
    first(),
    map(() => true),
    catchError(() => of(false)),
  );
};
